import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TranslationContext } from "../../context/TranslationContext";
import { getCurrentLanguageId } from "../../lang/utils";
import { TranslationContextInterface } from "../../entities/Language";
import { useAppDispatch } from "../../store/store";
import { fetchOneMixByFuchs } from "../../components/MixDetails/actions";
import { useParams } from "react-router-dom";
import { MixDetailsStyled } from "./MixDetailsStyled";
import {
  getMixDetails,
  getMixLoading,
} from "../../components/MixDetails/selectors";
import { setCondiments } from "../../components/Condiment/CondimentSlice";
import { getCondiments } from "../../components/Condiment/selectors";
import { getValueForKey } from "../../context/translationsUtils";
import CondimentWrapper from "../../components/Condiment/CondimentWrapper";
import Box from "../../UI/Box";
import CondimentSkeleton from "../../components/Condiment/CondimentSkeleton";
import SkeletonComponent from "../../components/SkeletonComponent/SkeletonComponent";
import Filter from "../../components/Filter";
import { SORTING_TYPE } from "../../entities/Filter";
import { sortByDirection } from "../../utils/sortByDirection";
import { CondimentInterface } from "../../entities/Condiment";
import { setBreadcrumbs } from "../../components/Breadcrumbs/slice/BreadcrumbsSlice";
import {
  resetMixtureState,
  setMixtureName,
  setMixtureOption,
  setSelectedWeight,
} from "../../components/Mixture/MixtureSlice";

const MixDetails: React.FC = () => {
  const [sort, setSort] = useState<SORTING_TYPE>(SORTING_TYPE.ASC);
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const languageId = getCurrentLanguageId();
  const dispatch = useAppDispatch();
  const mix = useSelector(getMixDetails);
  const { spices = [], herbs = [] } = useSelector(getCondiments);
  const [sortedSpices, setSortedSpices] = useState<CondimentInterface[]>([]);
  const [sortedHerbs, setSortedHerbs] = useState<CondimentInterface[]>([]);
  const isLoading = useSelector(getMixLoading);
  const { mixId } = useParams<{ mixId: string }>();

  useEffect(() => {
    dispatch(fetchOneMixByFuchs(mixId as string));
    dispatch(resetMixtureState());
  }, [mixId, languageId, dispatch]);

  useEffect(() => {
    if (mix && mix.condiments) {
      dispatch(setCondiments(mix.condiments));
      dispatch(setMixtureName(mix.name));
      dispatch(setSelectedWeight(mix.weight));
      dispatch(setMixtureOption(mix.receipeType));
      dispatch(setBreadcrumbs({ name: mix.name, level: 1, link: null }));
    }
  }, [mix, dispatch]);

  useEffect(() => {
    if (spices.length || herbs.length) {
      const sortedByDirectionSpices = sortByDirection([...spices], sort);
      const sortedByDirectionHerbs = sortByDirection([...herbs], sort);
      setSortedSpices(sortedByDirectionSpices);
      setSortedHerbs(sortedByDirectionHerbs);
    }
  }, [sort, spices, herbs]);

  return (
    <Box>
      <MixDetailsStyled>
        <Filter sort={sort} setSort={setSort} />
        <SkeletonComponent
          isLoading={isLoading}
          skeleton={<CondimentSkeleton />}
        >
          <CondimentWrapper
            title={getValueForKey(translations, "custom.choose_spices_hint")}
            condiments={sortedSpices}
            disableSelected={true}
          />
          <CondimentWrapper
            title={getValueForKey(translations, "custom.choose_herbs_hint")}
            condiments={sortedHerbs}
            disableSelected={true}
          />
        </SkeletonComponent>
      </MixDetailsStyled>
    </Box>
  );
};

export default MixDetails;
